import React from "react";
import { Box, Container, Grid, Typography, Button, Paper } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const benefits = [
  {
    icon: <SyncIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Sincronización en Tiempo Real",
    description:
      "Evita sobreventas y muestra disponibilidad en tiempo real en tu sitio web.",
    bgColor: "#565254",
  },
  {
    icon: (
      <IntegrationInstructionsIcon sx={{ fontSize: 40, color: "#EE964B" }} />
    ),
    title: "Integración Perfecta",
    description:
      "El motor de reservas se integra sin problemas con tu página y canales de venta.",
    bgColor: "#565254",
  },
  {
    icon: <HomeWorkIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Gestión Centralizada",
    description:
      "Administra todas tus reservas desde un único lugar, de manera simple y eficiente.",
    bgColor: "#565254",
  },
  {
    icon: <AttachMoneyIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Aumenta tus Ingresos",
    description:
      "Optimiza precios y maximiza tus ganancias sin intermediarios.",
    bgColor: "#565254",
  },
];

function HeroBookingEngine() {
  return (
    <Box
      sx={{
        scrollSnapAlign: "start",
                background: "linear-gradient(0deg, #d2c2f2, #903AF2)",

        height: "100%",
        color: "white",
        py: 8,
        px: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Información principal */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              color={"#fff"}
              sx={{ fontFamily: "'Red Hat Display', sans-serif" }}
            >
              Motor de Reservas Ubika
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                fontFamily: "'Merriweather Sans', sans-serif",
                color: "#fff",
              }}
            >
              Aumentá tus ingresos con un sistema de reservas directo, simple y
              eficiente. El motor de reservas de Ubika permite a tus huéspedes
              reservar directamente desde tu sitio web sin intermediarios,
              mostrando disponibilidad en tiempo real y optimizando cada
              oportunidad de venta.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#EE964B",
                color: "#ffffff",
                fontWeight: "bold",
                fontFamily: "'Red Hat Display', sans-serif",
                px: 4,
                py: 1.5,
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#d97e3e",
                },
              }}
            >
              Ver Demo
            </Button>
          </Grid>

          {/* Beneficios principales */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: "12px",
                      backgroundColor: benefit.bgColor,
                      color: "#ffffff",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                      },
                    }}
                  >
                    {benefit.icon}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mt: 2 }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2">
                      {benefit.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HeroBookingEngine;
